import React, { FC, useEffect, useRef } from 'react';
import { useDispatchEx } from "../../hooks/redux";
import Sidebar from "../organisms/Sidebar/Sidebar";
import { io } from "socket.io-client";
import { createSound } from "../../helpers/scripts";
import soundNew from '../../assets/sounds/new.mp3';
import {
    incrementUnreadCount,
    incrementGlobalUnreadCount,
    addNewOrder
} from "../../redux/slices/orders/ordersSlice";
import { asyncGetGlobalUnreadCountAction } from "../../redux/slices/orders/ordersAction";
import { useLocation } from "react-router-dom"; // <-- Импортируем хук

interface ILayout {
    children: React.ReactNode;
}

const AdminLayout: FC<ILayout> = ({ children }) => {
    const dispatch = useDispatchEx();
    const location = useLocation(); // <-- Получаем текущий путь
    const pathRef = useRef(location.pathname);

    // Сохраняем актуальный путь в ref, чтобы внутри замыкания сокета всегда была свежая инфа
    useEffect(() => {
        pathRef.current = location.pathname;
    }, [location]);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });

        const token = localStorage.getItem('token');

        dispatch(asyncGetGlobalUnreadCountAction());

        const socket = io(`${process.env.REACT_APP_URL_WSS}`, {
            extraHeaders: {
                Authorization: `Bearer ${token}`,
            },
        });

        socket.on('receiveNewOrder', (newOrder: any) => {
            createSound(soundNew);
            dispatch(addNewOrder(newOrder));
            dispatch(incrementGlobalUnreadCount());
        });

        socket.on('receiveSupportMessageGlobal', (data: any) => {
            // 1. Игнорируем уже прочитанные сообщения (например, логи и статусы от админа)
            if (data.isRead) return;

            if (data.fromId === -1 || data.fromId === data.orderId) {
                const currentPath = pathRef.current;

                // 2. Проверяем, находится ли админ прямо сейчас в чате этого ордера
                // Путь обычно выглядит как /admin/orders/123 или подобным образом
                const isChatOpened = currentPath.endsWith(`/${data.orderId}`) || currentPath.includes(`/${data.orderId}/`);

                if (isChatOpened) {

                } else {
                    // Чат не открыт, всё идет по стандарту: звук + плюсуем счетчики
                    createSound(soundNew);
                    dispatch(incrementGlobalUnreadCount());
                    dispatch(incrementUnreadCount(data.orderId));
                }
            }
        });

        return () => {
            socket.disconnect();
        };
    }, [dispatch]);

    return (
        <>
            <main className={'main-admin'}>
                <Sidebar />
                {children}
            </main>
        </>
    );
};

export default AdminLayout;